module.exports = __webpack_public_path__ + "static/obvious_checkout_2-adad1f8d7bbeae7c41d8b4bb2f38832f.jpg";